import { call, put, takeLatest } from "redux-saga/effects";
import { 
  SUBMIT_RENEWAL_REQUEST, 
  submitRenewalSuccess, 
  submitRenewalFailure 
} from "../actions/renewalAgentActions";
import { fetchRenewalAgent } from "../../../services/accIqService";

function* handleSubmitRenewal(action) {
  try {
    const response = yield call(fetchRenewalAgent, 
        action.payload.accountName, 
        action.payload.contact,
        action.payload.consumptionFile,
        action.payload.outputFile,
        action.payload.account_id,
        action.payload.response_type
    );
    yield put(submitRenewalSuccess(response?.html || "No closure note generated."));
  } catch (error) {
    yield put(submitRenewalFailure("Failed to submit renewal request."));
  }
}

export function* watchRenewalRequests() {
  yield takeLatest(SUBMIT_RENEWAL_REQUEST, handleSubmitRenewal);
}
